// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUnappliedFundsByOrganizationDto
 */
export interface IUnappliedFundsByOrganizationDto {
    /**
     * 
     * @type {number}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    org_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    organization_type?: IUnappliedFundsByOrganizationDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    unapplied_funds?: number;
    /**
     * 
     * @type {number}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    unpaid_invoices_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IUnappliedFundsByOrganizationDto
     */
    unpaid_invoices_count?: number;
}

/**
* @export
* @enum {string}
*/
export enum IUnappliedFundsByOrganizationDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}


/**
 * Check if a given object implements the IUnappliedFundsByOrganizationDto interface.
 */
export function instanceOfIUnappliedFundsByOrganizationDto(value: object): value is IUnappliedFundsByOrganizationDto {
    return true;
}

export function IUnappliedFundsByOrganizationDtoFromJSON(json: any): IUnappliedFundsByOrganizationDto {
    return IUnappliedFundsByOrganizationDtoFromJSONTyped(json, false);
}

export function IUnappliedFundsByOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUnappliedFundsByOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'org_id': json['org_id'] == null ? undefined : json['org_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'unapplied_funds': json['unapplied_funds'] == null ? undefined : json['unapplied_funds'],
        'unpaid_invoices_amount': json['unpaid_invoices_amount'] == null ? undefined : json['unpaid_invoices_amount'],
        'unpaid_invoices_count': json['unpaid_invoices_count'] == null ? undefined : json['unpaid_invoices_count'],
    };
}

export function IUnappliedFundsByOrganizationDtoToJSON(json: any): IUnappliedFundsByOrganizationDto {
    return IUnappliedFundsByOrganizationDtoToJSONTyped(json, false);
}

export function IUnappliedFundsByOrganizationDtoToJSONTyped(value?: IUnappliedFundsByOrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_id': value['org_id'],
        'organization_name': value['organization_name'],
        'organization_type': value['organization_type'],
        'subsidiary_name': value['subsidiary_name'],
        'unapplied_funds': value['unapplied_funds'],
        'unpaid_invoices_amount': value['unpaid_invoices_amount'],
        'unpaid_invoices_count': value['unpaid_invoices_count'],
    };
}

